import { render, staticRenderFns } from "./ChipStatusPedido.vue?vue&type=template&id=7b43b5bb&"
import script from "./ChipStatusPedido.vue?vue&type=script&lang=js&"
export * from "./ChipStatusPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports